<template>
  <v-container>
    <!--(팝업)개인 정보 변경-->
    <v-dialog
      v-model="persondialog"
      @keydown.esc="persondialog = false"
      max-width="600px"
      persistent
    >
      <v-card id="popStyle03">
        <!--팝업 제목-->
        <v-card-title class="title">
          <div class="popCon_txt">
            <v-tabs v-model="tabs" class="popSet_userinfo">
              <v-tab>회원탈퇴</v-tab>
            </v-tabs>
          </div>
        </v-card-title>
        <!--팝업 내용-->
        <v-card-text>
          <v-row no-gutters class="popCon">
            <v-tabs-items v-model="tabs">
              <!--회원탈퇴-->
              <v-tab-item>
                <div v-if="this.userDelYn === 1">
                  <div class="popCon_txt">
                    회원탈퇴 신청에 앞서 주의사항을 안내해 드립니다.
                  </div>
                  <div class="popCon_txt">
                    <div class="dot_tt">개인정보 처리 안내</div>
                    <ul class="pattern_ul_terms">
                      <li>
                        - 회원탈퇴 신청을 하시면 즉각 해지조치 되며 다시
                        로그인할 수 없습니다.
                      </li>
                      <li>
                        - 가입시 부여 받은 블록체인 주소는 삭제되지 않습니다.
                      </li>
                      <li>
                        - 탈퇴 전 반드시 필요 데이터를 다운 받으시기 바랍니다.
                      </li>
                      <li>
                        - 기업 관리자인 경우 탈퇴하시면 해당 기업의 담당자에게
                        관리자 권한이 부여됩니다.<br />(별도로 관리자 변경 하지
                        않으면 가입순서에 따라 관리자 권한이 부여됩니다)
                      </li>
                    </ul>
                  </div>
                  <div class="popCon_txt">
                    <div class="dot_tt">요금 안내</div>
                    <ul class="pattern_ul_terms">
                      <li>
                        - 요금 안내서비스 미납금액이 있는 경우 탈퇴 처리되지
                        않습니다. 결제 완료 후 탈퇴 신청 해주세요.
                      </li>
                    </ul>
                  </div>
                </div>
                <div v-else-if="this.userDelYn === 3">
                  <div class="popCon_txt">
                    회원 탈퇴를 진행하기 전 기업 계약 관리자 정보를 확인해
                    주세요.<br />탈퇴를 진행하시겠습니까?
                  </div>
                  <div class="popCon_txt">
                    <div class="dot_tt">개인정보 처리 안내</div>
                  </div>
                  <v-card
                    class="list_carD_con"
                    v-for="(comList, index) of managerInfo"
                    :key="index"
                  >
                    <v-list-item class="carD_box_clB">
                      <div class="carD_01">
                        <div class="carD_01_txt">
                          {{ comList.organizationName }} ({{
                            comList.organizationRegistrationNumber
                              | regNumFilter
                          }})
                        </div>
                        <div class="dateBox">
                          <span class="st_txt">기업관리자</span>
                          <span class="st_txt"
                            >{{ comList.adminName }} ({{
                              comList.adminEmail
                            }})</span
                          >
                        </div>
                        <div class="dateBox">
                          <span class="st_txt">전자계약</span>
                          <span class="st_txt"
                            >{{ comList.cadminName }} ({{
                              comList.cadminEmail
                            }})</span
                          >
                        </div>
                      </div>
                    </v-list-item>
                  </v-card>
                </div>
                <div v-else>
                  <div class="popCon_txt">
                    계약 진행중에 회원 탈퇴하시면 계약을 완료 할 수 없습니다.<br />탈퇴를
                    진행하시겠습니까?
                  </div>
                  <div class="popCon_txt">
                    <div class="dot_tt">전자계약 현황 안내</div>
                    <ul class="pattern_ul_terms">
                      <li>
                        - {{ username }} 님께서 진행중인 전자계약서가
                        존재합니다.
                      </li>
                      <li>
                        - 회원 탈퇴를 하시면 해당 계약을 더 이상 진행할 수
                        없습니다.
                      </li>
                    </ul>
                  </div>
                </div>
              </v-tab-item>
            </v-tabs-items>
          </v-row>
        </v-card-text>

        <!--팝업 버튼-->
        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <v-card-actions class="justify-center">
              <div class="btnCon" v-if="this.userDelYn === 1">
                <v-btn class="btn_C01" text @click="getMangerInfo()"
                  >회원탈퇴</v-btn
                >
                <v-btn text @click="goCancel">취소</v-btn>
              </div>
              <div class="btnCon" v-else-if="this.userDelYn === 3">
                <v-btn class="btn_C01" text @click="checkCtrData()">확인</v-btn>
                <v-btn text @click="redirectIndex()">취소</v-btn>
              </div>
              <div class="btnCon" v-else>
                <v-btn class="btn_C01" text @click="AlertDelUser(2)"
                  >확인</v-btn
                >
                <v-btn text @click="goCancel">취소</v-btn>
              </div>
            </v-card-actions>
          </v-tab-item>
        </v-tabs-items>
        <!--/팝업 버튼-->
      </v-card>
    </v-dialog>
    <s-loading ref="loading"></s-loading>
    <s-confirm ref="confirm"></s-confirm>
  </v-container>
</template>

<script>
import { getMangerInfo, removeUserInfo } from "@/api/user";
import { search, today, lastMonth } from "@/api/contract/provision";

export default {
  name: "terminateMember",
  components: {},
  filters: {
    regNumFilter: function(value) {
      if (value) {
        return String(value).replace(/(\d{3})(\d{2})(\d{5})/, "$1-$2-$3");
      }
    }
  },
  data() {
    return {
      userDelYn: 1,
      persondialog: false,
      tabs: null,
      dialog01: true,
      pass_form: {
        old_password: "",
        password: "",
        password_re: ""
      },
      passChangeform: {
        userid: "",
        name: "",
        email: "",
        addr_main: "",
        phone: "",
        old_password: "",
        password: ""
      },
      listParam: {
        page: 0,
        size: 10
      },
      searchData: {
        selectValue: "",
        fromDataValue: "",
        toDataValue: "",
        metaData: [],
        dateChecker: "",
        keyword: []
      },
      managerInfo: []
    };
  },
  created() {},
  mounted() {
    this.userid = this.$store.state.user.userid;
  },
  methods: {
    open() {
      this.persondialog = true;
    },

    getMangerInfo() {
      this.managerInfo = [];
      this.CadminCnt = 0;
      this.$refs.loading.start("입력 정보 확인 중");
      getMangerInfo().then(Response => {
        if (Response.rcode === 20000) {
          if (Response.rdata.AdminCnt > 0) {
            this.managerInfo = Response.rdata.AdminsInfo;
            this.CadminCnt = Response.rdata.CadminCnt;
            this.userDelYn = 3;
          } else {
            this.checkCtrData();
          }
          this.$refs.loading.end();
        } else {
          this.$refs.loading.end();
          this.$refs.confirm.open(
            "alert",
            "정보 조회",
            "기업정보 조회를 확인 할 수 없습니다. 고객센터로 문의하세요."
          );
        }
      });
    },
    checkCtrData() {
      if (this.CadminCnt > 0) {
        this.$refs.confirm.open(
          "alert",
          "회원 탈퇴",
          "전자계약 관리자이신 경우, 탈퇴를 원하실 경우 기업 관리자에게 전자계약 관리자 수정을 요청하여 주십시오."
        );
      } else {
        this.searchData.fromDataValue = lastMonth();
        this.searchData.toDataValue = today();
        this.searchData.dateChecker = "CTR_SRCH_KIND_FROMDT";
        this.$refs.loading.start("입력 정보 확인 중");
        search(this.listParam, this.searchData).then(Response => {
          if (Response.rcode === 20000) {
            this.$refs.loading.end();
            if (
              Response.rdata.totalCount !== undefined &&
              Response.rdata.totalCount > 0
            ) {
              this.AlertDelUser(1);
            } else {
              this.AlertDelUser(2);
            }
          } else {
            this.$refs.loading.end();
            this.$refs.confirm.open(
              "alert",
              "회원 탈퇴",
              "계약정보 조회를 확인 할 수 없습니다. 고객센터로 문의하세요."
            );
          }
        });
      }
    },
    goCancel() {
      this.persondialog = false;
    },
    AlertDelUser(value) {
      if (value === 1) {
        this.userDelYn = 2;
      } else {
        this.$refs.confirm
          .open(
            "confirm",
            "회원 탈퇴",
            "전자계약 관리자이신 경우, 탈퇴를 원하실 경우 기업 관리자에게 전자계약 관리자 수정을 요청하여 주십시오."
          )
          .then(() => {
            this.userRegisterRemove();
          });
      }
    },
    userRegisterRemove() {
      this.$refs.loading.start("입력 정보 확인 중");
      this.$nextTick(() => {
        removeUserInfo(JSON.stringify({ userid: this.userid })).then(
          Response => {
            if (
              Response.rdata !== undefined &&
              Response.rdata.rcode === 20000
            ) {
              this.$refs.loading.end();
              this.AlertDelUserOk();
            } else {
              this.$refs.loading.end();
              var msg = "";
              if (Response.rdata === undefined) {
                msg = Response.message;
              } else {
                msg = Response.rdata.message;
              }
              this.$refs.confirm.open("alert", msg);
            }
          }
        );
      });
    },
    AlertDelUserOk() {
      this.$refs.confirm
        .open(
          "confirm",
          "회원 탈퇴",
          "글로싸인엔터프라이즈 탈퇴가 완료되었습니다. 그동안 이용해 주셔서 감사합니다. "
        )
        .then(() => {
          this.$store.dispatch("LogOut").then(() => {
            this.$router.push("/");
            location.reload();
          });
        });
    },
    redirectIndex() {
      this.userDelYn = 1;
    }
  }
};
</script>
